import { render, staticRenderFns } from "./dataAdminForm.vue?vue&type=template&id=d3269a78&scoped=true"
import script from "./dataAdminForm.vue?vue&type=script&lang=js"
export * from "./dataAdminForm.vue?vue&type=script&lang=js"
import style0 from "./dataAdminForm.vue?vue&type=style&index=0&id=d3269a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3269a78",
  null
  
)

export default component.exports